/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useSelectContato from "~components/Form/hooks/useSelectContato";

const useCargo = (formikRef) => {
  const cargoSelect = useSelectContato("cargo");
  const [cargo, setCargo] = useState(0);
  const [cargos, setCargos] = useState([]);

  useEffect(() => {
    const fetchCargo = async () => {
      const c = [];
      await db.cargos.each((a) => c.push(a));
      setCargos(c);
    };

    fetchCargo();
  }, []);

  const optionsCargo = useMemo(() => prepareForOptions(cargos, ["nome"], "id"), [cargos]);

  const handleCargoChange = (index, setFieldValue, setFieldTouched) => (e) => {
    cargoSelect.upDateValue(index, e);
    formikRef?.current?.setFieldValue(`contatos[${index}].cargoId`, e.value);
    setTimeout(() => formikRef?.current?.setFieldTouched(`contatos[${index}].cargoId`, true));
  };

  const SetSelectCargo = async (setCargos) => {
    for (const [idx, cgs] of setCargos.entries()) {
      const cargoId = cgs?.cargoId ?? cgs?.cargoContato?.id;
      const cargoLabel = cgs?.cargo ?? cgs?.cargoContato?.nome;

      if (cargoId) {
        cargoSelect.upDateValue(idx, { label: cargoLabel, value: cargoId });
        await formikRef.current.setFieldValue(`contatos[${idx}].cargoId`, cargoId, false);
        if (cargoLabel !== undefined) {
          await formikRef.current.setFieldValue(`contatos[${idx}].cargo`, cargoLabel, false);
        }
        formikRef.current.setFieldTouched(`contatos[${idx}].cargoId`, true, false);
      }

    }
  };

  return {
    optionsCargo,
    cargos,
    cargo,
    cargoSelect,
    handleCargoChange,
    SetSelectCargo
  };
};

export default useCargo;